var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useEffect, useState } from 'react';
import { difference, intersection, keys } from 'lodash';
import useForm from 'react-hook-form';
import { useIntl } from 'react-intl';
import { number, object, string } from 'yup';
import { useAuth0 } from '@auth0/auth0-react';
import { LoginFormStyle } from './login-form-style';
import { useAppleLogin } from './use-apple-login';
import { useFacebookLogin } from './use-facebook-login';
import { useGoogleLogin } from './use-google-login';
import { AppleButton, Button, FaceBookButton, GoogleButton } from '../buttons';
import { Checkbox } from '../Checkbox';
import { InputError, InputField } from '../Input';
import { AuthModalContext } from '../providers';
import { useCookies, useEventListener, useNavigation, useRecaptcha, useRequest } from '../../shared/hooks';
export var LoginForm = function (_a) {
    var _b = _a.isModal, isModal = _b === void 0 ? true : _b, redirectTo = _a.redirectTo, _c = _a.showSocialLogins, showSocialLogins = _c === void 0 ? true : _c, team = _a.team, _d = _a.showAuth0, showAuth0 = _d === void 0 ? false : _d;
    var _e = useRecaptcha(), isRecaptchaLoading = _e.isRecaptchaLoading, recaptchaRef = _e.recaptchaRef, executeRecaptcha = _e.executeRecaptcha, recaptchaResponse = _e.recaptchaResponse, recaptchaError = _e.recaptchaError;
    var execute = useRequest({ isAjaxRequest: true }).execute;
    var path = useNavigation().path;
    var appleLogin = useAppleLogin().appleLogin;
    var _f = useFacebookLogin(redirectTo), facebookLogin = _f.facebookLogin, isFacebookLoading = _f.isFacebookLoading;
    var _g = useGoogleLogin(redirectTo), googleLogin = _g.googleLogin, isGoogleLoading = _g.isGoogleLoading;
    var _h = useAuth0(), loginWithPopup = _h.loginWithPopup, logout = _h.logout, isAuthenticated = _h.isAuthenticated, isLoading = _h.isLoading, user = _h.user;
    var authContext = useContext(AuthModalContext);
    var _j = __read(useState(''), 2), generalError = _j[0], setGeneralError = _j[1];
    var _k = __read(useState(0), 2), loginAttempts = _k[0], setLoginAttempts = _k[1];
    var _l = __read(useState(false), 2), isSubmitting = _l[0], setIsSubmitting = _l[1];
    var cookies = useCookies().cookies;
    var csrfToken = cookies && cookies.YII_CSRF_TOKEN ? cookies.YII_CSRF_TOKEN : '';
    var intl = useIntl();
    var errorInvalidEmail = intl.formatMessage({
        id: 'components.login-form.email.error.not-valid',
        defaultMessage: 'Email Address is not a valid email address.',
        description: 'Validation error message for email on login form.',
    });
    var errorEmailRequired = intl.formatMessage({
        id: 'components.login-form.email.error.required',
        defaultMessage: 'Email is required',
        description: 'Validation error message for required email on login form.',
    });
    var errorPasswordRequired = intl.formatMessage({
        id: 'components.login-form.password.error.required',
        defaultMessage: 'Password is required',
        description: 'Validation error message for required password on login form.',
    });
    var errorTeamNameRequired = intl.formatMessage({
        id: 'components.login-form.team-name.error.required',
        defaultMessage: 'Company is required',
        description: 'Validation error message for required team name on login form.',
    });
    var schema = object().shape({
        email: string().trim().email(errorInvalidEmail).required(errorEmailRequired),
        password: string().trim().required(errorPasswordRequired),
        team: number(),
        teamName: string().when('team', {
            is: function (val) { return val === 1; },
            then: string().required(errorTeamNameRequired),
        }),
    });
    var enterKeyHandler = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var validationResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.keyCode === 13)) return [3, 2];
                    event.preventDefault();
                    return [4, triggerValidation([{ name: 'email' }, { name: 'password' }])];
                case 1:
                    validationResult = _a.sent();
                    if (validationResult) {
                        onSubmit();
                    }
                    return [2];
                case 2: return [2];
            }
        });
    }); };
    useEventListener({ eventName: 'keydown', handler: enterKeyHandler });
    var _m = useForm({
        mode: 'onSubmit',
        validationSchema: schema,
    }), register = _m.register, handleSubmit = _m.handleSubmit, errors = _m.errors, setError = _m.setError, clearError = _m.clearError, getValues = _m.getValues, triggerValidation = _m.triggerValidation, setValue = _m.setValue;
    if (team && team.invitation) {
        setValue('email', team.invitation.email);
    }
    useEffect(function () {
        if (recaptchaResponse && recaptchaResponse !== '') {
            submitForm();
        }
    }, [recaptchaResponse]);
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (loginAttempts > 0 && !isRecaptchaLoading && recaptchaRef.current) {
                executeRecaptcha();
            }
            else {
                submitForm();
            }
            return [2];
        });
    }); };
    var submitForm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, postData, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSubmitting(true);
                    data = getValues();
                    postData = getPostData(data);
                    clearError();
                    setGeneralError('');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setLoginAttempts(function (prev) { return prev + 1; });
                    return [4, execute({ url: '/ajaxlogin', data: postData, method: 'POST' })];
                case 2:
                    response = _a.sent();
                    window.location = response.data.redirectTo;
                    return [3, 4];
                case 3:
                    error_1 = _a.sent();
                    handleErrorResponse(error_1);
                    setIsSubmitting(false);
                    return [2];
                case 4: return [2];
            }
        });
    }); };
    var getPostData = function (data) {
        var postData = new URLSearchParams();
        postData.append('LoginForm[email]', data.email);
        postData.append('LoginForm[password]', data.password);
        postData.append('YII_CSRF_TOKEN', csrfToken);
        postData.append('recaptcha', recaptchaResponse ? recaptchaResponse : '');
        if (path && path !== '') {
            postData.append('LoginForm[redirectTo]', path);
        }
        if (team && team.isLogin) {
            postData.append('LoginForm[teamName]', data.teamName);
        }
        if (team && team.invitation) {
            postData.append('LoginForm[teamInviteId]', team.invitation.id.toString());
        }
        if (redirectTo) {
            postData.set('LoginForm[redirectTo]', redirectTo);
        }
        return postData;
    };
    var handleErrorResponse = function (error) {
        var generalErrorMsg = intl.formatMessage({
            id: 'components.login-form.general-error',
            defaultMessage: 'Something went wrong. Please try again later',
            description: 'Message that shows up for general purpose.',
        });
        if (error.response.status > 400) {
            setGeneralError(generalErrorMsg);
            return;
        }
        var errors = error.response.data.errors;
        if (typeof errors === 'string') {
            setGeneralError(errors);
            return;
        }
        var inputErrorFields = intersection(schema._nodes, keys(errors));
        inputErrorFields.forEach(function (field) {
            setError(field, '', errors[field][0]);
        });
        var generalErrorFields = difference(keys(errors), inputErrorFields);
        generalErrorFields.forEach(function (field) {
            setGeneralError(errors[field]);
        });
    };
    var handleSignUp = function (event) {
        event.preventDefault();
        authContext.api.updateIsLogin(false);
    };
    var handleFacebookLogin = function (event) {
        event.preventDefault();
        if (showAuth0) {
            loginWithPopup({ display: 'popup', connection: 'facebook' });
        }
        else {
            facebookLogin();
        }
    };
    var handleGoogleLogin = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (!showAuth0) return [3, 2];
                    return [4, loginWithPopup({ display: 'popup', connection: 'google-oauth2' })];
                case 1:
                    _a.sent();
                    return [3, 4];
                case 2: return [4, googleLogin()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2];
            }
        });
    }); };
    var handleAppleLogin = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (!showAuth0) return [3, 2];
                    return [4, loginWithPopup({ display: 'popup', connection: 'apple' })];
                case 1:
                    _a.sent();
                    return [3, 4];
                case 2: return [4, appleLogin()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2];
            }
        });
    }); };
    var handleAuth0Submit = function (event) {
        var _a;
        event.preventDefault();
        var login_hint = (_a = getValues()) === null || _a === void 0 ? void 0 : _a.email;
        var display = 'popup';
        loginWithPopup({ display: display, login_hint: login_hint });
    };
    if (showAuth0) {
        var auth0LoadingMessage = intl.formatMessage({
            id: 'components.login-form.auth0.loading-message',
            description: 'A "Loading" message to display on the login form, when authentication is Auth0 and Auth0 is loading in the background.',
            defaultMessage: 'Loading ...',
        });
        var auth0LogOutMessage = intl.formatMessage({
            id: 'components.login-form.auth0.log-out-message',
            description: 'Label for log out button, when authentication form is Auth0.',
            defaultMessage: 'Log Out via Auth0',
        });
        if (isLoading) {
            return React.createElement("div", { "data-testid": "auth0-loading-div" }, auth0LoadingMessage);
        }
        if (isAuthenticated) {
            return (React.createElement("div", { className: "login-form", "data-testid": "auth0-lixp-form" },
                React.createElement("div", null,
                    React.createElement("img", { src: user.picture, alt: user.given_name }),
                    React.createElement("h2", null,
                        user.given_name,
                        " ",
                        user.family_name),
                    React.createElement("p", null, user.email)),
                React.createElement(Button, { color: "secondary", onClick: function () { return logout({ returnTo: window.location.origin }); }, text: auth0LogOutMessage })));
        }
    }
    var useFormSeparator = intl.formatMessage({
        id: 'components.form.separator.or',
        description: 'Word "or" used to separate social media login from email address login fields',
        defaultMessage: 'or',
    });
    var useForgotPassword = intl.formatMessage({
        id: 'components.form.forgot.password',
        description: 'Link redirecting the user to a page to retrieve their forgotten password',
        defaultMessage: 'Forgot password?',
    });
    var useNotAMemberYet = intl.formatMessage({
        id: 'components.form.not.a.member.yet',
        description: 'Question for the user if they are not a member. Colocated next to a link redirecting the user to signup',
        defaultMessage: 'Not a member yet?',
    });
    var useSignUp = intl.formatMessage({
        id: 'components.form.sign.up',
        description: 'Link redirecting the user to a page allowing them to sign up',
        defaultMessage: 'Sign Up.',
    });
    var rememberMeLabel = intl.formatMessage({
        id: 'components.login-form.remember-me',
        description: 'Label for checkbox to allow user to remain logged in on subsequent visits.',
        defaultMessage: 'Keep me signed in until I sign out',
    });
    var facebookButtonTitle = intl.formatMessage({
        id: 'components.login-form.social-button.facebook.title',
        defaultMessage: 'Continue with Facebook',
        description: 'Label for "sign in with Facebook" button.',
    });
    var googleButtonTitle = intl.formatMessage({
        id: 'components.login-form.social-button.google.title',
        defaultMessage: 'Continue with Google',
        description: 'Label for "sign in with Google" button.',
    });
    var appleButtonTitle = intl.formatMessage({
        id: 'components.login-form.social-button.apple.title',
        defaultMessage: 'Continue with Apple',
        description: 'Label for "sign in with Apple" button.',
    });
    var emailPlaceholder = intl.formatMessage({
        id: 'components.login-form.field.email-address.placeholder',
        defaultMessage: 'Email address',
        description: 'The placeholder text that appears within the email address field on the login form.',
    });
    var passwordPlaceholder = intl.formatMessage({
        id: 'components.login-form.field.password.placeholder',
        defaultMessage: 'Password',
        description: 'The placeholder text that appears within the password field on the login form.',
    });
    var companyPlaceholder = intl.formatMessage({
        id: 'components.login-form.field.company.placeholder',
        defaultMessage: 'Company',
        description: 'The placeholder text that appears within the company field on the login form (for Skillshare for Teams).',
    });
    var signInButtonLabel = intl.formatMessage({
        id: 'components.login-form.sign-in',
        description: 'Label for sign in button on login form.',
        defaultMessage: 'Sign In',
    });
    return (React.createElement(LoginFormStyle, null,
        React.createElement("form", { className: "login-form", method: "POST" },
            showSocialLogins && (React.createElement(React.Fragment, null,
                React.createElement(FaceBookButton, { isFacebookLoading: isFacebookLoading, text: facebookButtonTitle, onClick: handleFacebookLogin }),
                React.createElement(GoogleButton, { isGoogleLoading: isGoogleLoading, text: googleButtonTitle, onClick: handleGoogleLogin }),
                React.createElement(AppleButton, { text: appleButtonTitle, onClick: handleAppleLogin }),
                React.createElement("div", { className: "form-separator" },
                    React.createElement("p", null, useFormSeparator)))),
            React.createElement(InputError, { error: (errors.email && errors.email.message) ||
                    (generalError && generalError) ||
                    (recaptchaError && recaptchaError) }),
            React.createElement(InputField, { placeholder: emailPlaceholder, "aria-label": emailPlaceholder, type: 'email', name: 'email', className: "login-inputs-fields" + (team && team.invitation ? ' bold' : ''), ref: register, readOnly: team && team.invitation ? true : false }),
            !showAuth0 && (React.createElement(React.Fragment, null,
                React.createElement(InputError, { error: errors.password && errors.password.message }),
                React.createElement(InputField, { placeholder: passwordPlaceholder, "aria-label": passwordPlaceholder, type: 'password', name: 'password', ref: register, className: team ? 'login-inputs-fields' : '' }))),
            team && team.isLogin && (React.createElement(React.Fragment, null,
                React.createElement(InputError, { error: errors.teamName && errors.teamName.message }),
                React.createElement(InputField, { placeholder: companyPlaceholder, "aria-label": companyPlaceholder, type: 'text', name: 'teamName', ref: register, className: 'login-inputs-fields company' }),
                React.createElement(InputField, { type: 'hidden', name: 'team', value: 1, ref: register }))),
            !team && (React.createElement("div", { className: "remember-me" },
                React.createElement(Checkbox, { name: 'rememberMe', label: rememberMeLabel, ref: register }))),
            React.createElement(Button, { text: team ? team.submitText : signInButtonLabel, className: "full-width submit-btn" + (team ? ' team' : ''), onClick: showAuth0 ? handleAuth0Submit : handleSubmit(onSubmit), loading: showAuth0 ? false : isSubmitting }),
            !team && !showAuth0 && (React.createElement("div", { className: "forgot-password" },
                React.createElement("a", { className: "forgot-pass-text", target: "_blank", href: "/reset-password" }, useForgotPassword)))),
        isModal && (React.createElement("div", { className: "sign-up" },
            useNotAMemberYet,
            ' ',
            React.createElement("button", { className: "link", onClick: handleSignUp }, useSignUp))),
        React.createElement("div", { ref: recaptchaRef, className: "grecaptcha" })));
};
//# sourceMappingURL=login-form.js.map